export class TipoReferencium {
   tipoReferenciaId: string;
   codigo: number;
   descripcion: string;
}
